import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { memo, useEffect, useState } from "react";
import { mergeSlotProps } from "../providers/utils/slots";
import { mergeSx, useBelowBreakpoint } from "../system";
import { TextField } from "./TextField";
import { textInputBaseClasses } from "./TextInputBase";
export const shrinkingFieldClasses = {
    root: "MinervaShrinkingField-root",
};
export const ShrinkingField = memo(({ alwaysShrink, open: _open, onOpenChange, slotProps, className, sx, onFocus, onBlur, ...rest }) => {
    const mobile = useBelowBreakpoint("md");
    const [open, setOpen] = useState(_open ? _open : !mobile && !alwaysShrink);
    const handleOpen = () => {
        setOpen(true);
        onOpenChange?.(true);
    };
    const handleClose = () => {
        const open = !(mobile || alwaysShrink);
        setOpen(open);
        onOpenChange?.(open);
    };
    useEffect(() => {
        setOpen(_open ? _open : !mobile);
    }, [_open, mobile]);
    return (_jsx(TextField, { onFocus: (e) => {
            handleOpen();
            onFocus?.(e);
        }, onBlur: (e) => {
            handleClose();
            onBlur?.(e);
        }, className: clsx([shrinkingFieldClasses.root, className]), sx: mergeSx({
            [`& .${textInputBaseClasses["input-root"]}`]: {
                cursor: open ? "default" : "pointer",
                gap: open ? 1 : 0,
            },
            [`& .${textInputBaseClasses.input}`]: {
                transition: "width 0.2s ease-in-out",
                width: open ? 58 : 0,
                minWidth: 0,
            },
        }, sx), ...rest, slotProps: mergeSlotProps({
            inputRoot: {
                onClick: handleOpen,
            },
        }, slotProps) }));
});
//# sourceMappingURL=ShrinkingField.js.map